import React from "react";
import { FcCandleSticks } from "react-icons/fc";
import { GoFlame } from "react-icons/go";
import { TiArrowDownThick } from "react-icons/ti";
import { AiTwotoneAlert } from "react-icons/ai";
import ShowMoreText from "react-show-more-text";
import { readMore, readLess } from "../../../readMoreButtons";
import { getIndicatorPopoverDetails } from "../../Popover";
import { isMobile } from "react-device-detect";
import { OverlayTrigger, ProgressBar } from "react-bootstrap";
import getSummaryInCard, { navStyle } from "../SummaryInBottomOfCards";
import { GiRocket } from "react-icons/gi";
import Skeleton from "react-loading-skeleton";
import { progressBarStyle } from "../styles";
import { techIndicationToDisplayable } from "../../../../utils";
import useTheme from "../../../../context/ThemeProvider";

/**
 * Card containing all Technical Indicators
 */
export function TechnicalIndicatorsCard({ analysisData }) {

  const { theme } = useTheme();

  if (!analysisData) {
    return loadingSkeleton();
  } else if (analysisData === "error") {
    return fatalError();
  }

  const { summary, results } = analysisData;
  return (
    <div
      className="card card-crypto-portfolio animated fadeInDown"
      style={{
        borderRadius: 10,
        boxShadow: "0 0 10px rgb(28 39 60 / 10%)",
        borderColor: "var(--border-4)",
      }}
    >
      <div className="card-body">
        <h4>
          <FcCandleSticks
            size={25}
            style={{ marginBottom: 2, marginRight: 3 }}
          />
          Análise Técnica
        </h4>

        <ShowMoreText
          lines={3}
          more={readMore}
          less={readLess}
          expanded={false}
          truncatedEndingComponent={"..."}
          className="show-more-text"
        >
          <span style={{ textAlign: "left" }}>
            Ao analisar gráficos e históricos do ativo, é possível determinar
            indicadores técnicos, separamos os mais usados por profissionais,
            prontos para uso e de fácil visualização.
          </span>
          {isMobile && (
            <span style={{ fontWeight: 500 }}>
              {" "}
              Hey! você pode obter mais detalhes sobre cada indicador apenas
              tocando nele.
            </span>
          )}
        </ShowMoreText>
        <div className="table-responsive">
          <table className="table mg-b-0">
            <thead>
              <tr>
                <th>Indicador</th>
                <th>Indicação</th>
              </tr>
            </thead>
          </table>

          {results.map((item, i) => {
            let indicationDetails = techIndicationToDisplayable(
              item.value,
              theme
            );
            return (
              <OverlayTrigger
                placement={isMobile ? "top" : "left"}
                delay={{ show: 100, hide: 100 }}
                overlay={getIndicatorPopoverDetails({
                  contentCategory: 0,
                  contentId: i,
                })}
                key={i}
              >
                <div
                  className={"invoice-info-row text-center" + (indicationDetails.backgroundColor ? " highlight" : "")}
                  style={{
                    backgroundColor: indicationDetails.backgroundColor,
                  }}
                >
                  <span>{item.name}</span>
                  <span
                    style={{ color: indicationDetails.color }}
                    className="text-center"
                  >
                    <ProgressBar
                      variant={indicationDetails.progressBar.variant}
                      now={indicationDetails.progressBar.percent}
                      style={progressBarStyle}
                      key={i}
                    />
                    {indicationDetails.name}
                  </span>
                </div>
              </OverlayTrigger>
            );
          })}
        </div>
      </div>
      <nav className="nav" style={navStyle}>
        {getSummaryBlock(summary)}
      </nav>
    </div>
  );
}

export const TechnicalIndicatorsCardMemo = React.memo(TechnicalIndicatorsCard);

const getSummaryBlock = (data) => {
  let qntBuy = data.qntBuy;
  let qntSell = data.qntSell;
  let qntAlerts = data.qntAlerts;

  let allSummary = [
    {
      name: "Compra",
      value: qntBuy,
      color: "#388e3c",
      icon: <GoFlame />,
    },
    {
      name: "Venda",
      value: qntSell,
      color: "#ef5350",
      icon: <TiArrowDownThick />,
    },
    {
      name: "Alerta",
      value: qntAlerts,
      color: "fdd835",
      icon: <AiTwotoneAlert />,
    },
  ];

  return getSummaryInCard(allSummary);
};

const fatalError = () => {
  return (
    <div
      className="card card-crypto-portfolio"
      style={{
        borderRadius: 10,
        boxShadow: "0 0 10px rgb(28 39 60 / 10%)",
        borderColor: "var(--border-4)",
      }}
    >
      <div className="card-body mg-t-40">
        <center>
          <span>
            <GiRocket size={48} />
          </span>
          <h4>Houston, temos um problema!</h4>
          <p>
            Infelizmente, alguns dados não aterrissaram da maneira correta.
            <br />
            <a href={"?"}>Clique aqui para tentar novamente.</a>
            <br />
          </p>
        </center>
      </div>
    </div>
  );
};

const loadingSkeleton = () => {
  return (
    <div
      className="card card-crypto-portfolio animated fadeInDown"
      style={{
        borderRadius: 10,
        boxShadow: "0 0 10px rgb(28 39 60 / 10%)",
        borderColor: "var(--border-4)",
      }}
    >
      <div className="card-body">
        <h4>
          <FcCandleSticks
            size={25}
            style={{ marginBottom: 2, marginLeft: 5 }}
          />{" "}
          Análise técnica
        </h4>

        <ShowMoreText
          /* Default options */
          lines={3}
          more={readMore}
          less={readLess}
          expanded={false}
          truncatedEndingComponent={"..."}
          className="show-more-text"
        >
          <span style={{ textAlign: "left" }}>
            Ao analisar gráficos e históricos do ativo, é possível determinar
            indicadores técnicos, separamos os mais usados por profissionais,
            prontos para uso e de fácil visualização.
          </span>
        </ShowMoreText>
        <div className="table-responsive">
          <table className="table mg-b-0">
            <thead>
              <tr>
                <th>Indicador</th>
                <th>Indicação</th>
              </tr>
            </thead>
          </table>
          <center>
            <Skeleton
              style={{ marginTop: 10 }}
              height={15}
              count={8}
              width={"95%"}
            />
          </center>
        </div>
      </div>
    </div>
  );
};
